<template>
  <div>
    <div class="transactions-list-modal">
      <el-dialog :visible.sync="dialogVisible" :append-to-body="false" :close-on-click-modal="false" width="700px">
        <template slot="title">
          <span>{{ $t('components.detail') }}</span>
          <el-tag class="tag-custom link-tag" :type="getCheckoutOrderStatusMap(status).type"> {{ getCheckoutOrderStatusMap(status).label }}</el-tag>
        </template>

        <div class="total">
          <div class="num-container">
            <div class="txt">{{ $t('payment_links.order_amount') }}</div>
            <div class="num">
              {{ $store.getters.currency || 'PHP' }}
              {{ amount | toDivideWithDot }}
            </div>
          </div>
        </div>

        <el-tabs v-model="activeName" type="card" class="tab-container">
          <el-tab-pane :label="$t('payment_links.overview')" name="Order">
            <Order is="Order" key="Order" :order-data="orderData" />
          </el-tab-pane>
          <el-tab-pane :label="$t('payment_links.checkout_details')" name="CheckoutDetail">
            <CheckoutDetail is="CheckoutDetail" key="CheckoutDetail" :transaction-data="transactionData" />
          </el-tab-pane>
          <el-tab-pane :label="$t('payment_links.transaction_details')" name="TransactionDetail">
            <TransactionDetail is="TransactionDetail" key="TransactionDetail" :transaction-data="transactionData" @onClickDetailBtn="onClickDetailBtn" />
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
    </div>

    <PaymentDetailsModal ref="paymentDetailsModal" :detail-id="detailId" />

  </div>
</template>
<script>
import { detailCheckout } from '@/api/payment-link/payment-link'
import { checkoutOrderStatusMap } from '@/utils/maps'

export default {
  name: 'Transactions_List_Modal',
  components: {
    Order: () => import('../tabs/orderDetail.vue'),
    CheckoutDetail: () => import('../tabs/checkoutDetail.vue'),
    TransactionDetail: () => import('../tabs/transactionDetail.vue'),
    PaymentDetailsModal: () => import('../Modal/PayinDetailsModal.vue')
  },
  data() {
    return {
      dialogVisible: false,
      orderData: {},
      transactionData: {},
      activeName: 'Order',
      amount: 0,
      status: null,
      detailId: ''
    }
  },
  computed: {
    getCheckoutOrderStatusMap() {
      return val => checkoutOrderStatusMap(val)
    }
  },
  methods: {
    showModal(checkout_id) {
      this.dialogVisible = true
      detailCheckout({ checkout_id, link_no: this.$route.query.link_no }).then(res => {
        this.orderData = res.data
        this.transactionData = res.data
        this.amount = res.data?.payment_checkout_order?.order_amount
        this.status = res.data?.payment_checkout_order?.status
      })
    },
    onClickDetailBtn(transaction_id) {
      this.detailId = transaction_id
      this.$refs.paymentDetailsModal.changModalStatus(true)
    }
  }
}
</script>

<style scoped lang="scss">
.transactions-list-modal{
  ::v-deep .el-dialog__header{
    padding: 12px 24px;
    height: 48px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.20);
    .el-dialog__headerbtn{
      top: 16px;
    }
    span:not(.link-tag){
      color: #1B4AEF;
      font-size: 16px;
      font-weight: 600;
      margin-right: 12px;
    }
    .link-tag{
      font-size: 10px;
      height: 20px;
      border-radius: 20px;
      line-height: 20px;
    }
  }
  ::v-deep .el-dialog__body{
    padding: 12px 0;
  }
  .total{
    margin: 8px 24px 12px;
    .num-container{
      display: inline-block;
      .txt{
        margin-bottom: 16px;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.2;
        color: #4B5567;
      }
      .num{
        font-size: 24px;
        font-weight: 600;  font-family: 'Inter-SemiBold';
        line-height: 1.2;
        color:  #3855F1;
      }
    }
    .line{
      display: inline-block;
      margin:0 24px;
      width: 1px;
      height: 60px;
      background:#D3D7DF;
      vertical-align: -4px;
    }
  }
  .tab-container{
    // margin: 0 24px;
    ::v-deep .el-tabs__item{
      font-size: 12px;
      padding: 0 12px;
    }
    ::v-deep .el-tabs__header{
      margin: 0 24px;
    }
  }
  .tag-custom{
    border-radius: 3px;
    padding: 0 30px;
    height: 28px;
    line-height: 28px;
    border: none;
    &.el-tag--info{
      color: #B45309;
      background-color: #FDE68A;
    }
    &.el-tag--success{
      color: #047857;
      background-color: #A7F3D0;
    }
    &.el-tag--danger{
      color: #71110E;
      background-color: #FCA5A5;
    }
  }
}
</style>
